// Turns a keywords / seed-channels textarea into a list: one item per line or
// comma, trimmed, blanks dropped, case-insensitive duplicates removed (the
// first spelling wins). The backend applies the same normalization.
export function parseListInput(text: string): string[] {
  const seen = new Set<string>();
  const items: string[] = [];
  text.split(/[\n,]/).forEach((raw) => {
    const item = raw.trim();
    if (!item) return;
    const key = item.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    items.push(item);
  });
  return items;
}
